// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.

// needed to use lodash/set with numeric object keys
// more info: https://github.com/lodash/lodash/issues/1316
export const ID_PREFIX = "id-";
